var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [
            _c("span", { staticStyle: { color: "#417ced" } }, [
              _vm._v("会员客户管理"),
            ]),
          ]),
          _c("el-breadcrumb-item", [_vm._v("客户信息字段设定")]),
        ],
        1
      ),
      _c("div", { staticClass: "query" }, [
        _c("div", [_vm._v("客户信息字段设定")]),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("el-input", {
                  attrs: {
                    size: "mini",
                    placeholder: "请输入应用名称",
                    "prefix-icon": "el-icon-search",
                    maxlength: "50",
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "-1px" },
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.searchEvent },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.setEvent } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "20px" },
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = true
                  },
                },
              },
              [_vm._v("新增字段")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { stripe: "", align: "center", data: _vm.tableData.list },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "应用名称", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.applicationName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "客户信息字段名称", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.edit
                          ? [
                              _c("el-input", {
                                staticClass: "edit-input",
                                attrs: { size: "small", maxlength: "50" },
                                model: {
                                  value: scope.row.propertyName,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "propertyName", $$v)
                                  },
                                  expression: "scope.row.propertyName",
                                },
                              }),
                            ]
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.propertyName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "字段编码", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.edit
                          ? [
                              _c("el-input", {
                                staticClass: "edit-input",
                                attrs: { size: "small", maxlength: "50" },
                                model: {
                                  value: scope.row.propertyCode,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "propertyCode", $$v)
                                  },
                                  expression: "scope.row.propertyCode",
                                },
                              }),
                            ]
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.propertyCode)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.$moment(scope.row.createdTime)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "option" }, [
                          _vm.parArray.indexOf("fieldPrevent") != -1 &&
                          scope.row.edit
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.update(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              )
                            : _vm._e(),
                          scope.row.edit &&
                          _vm.parArray.indexOf("fieldPrevent") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      scope.row.edit = false
                                      scope.row.applicationName =
                                        scope.row.applicationName1
                                      scope.row.propertyCode =
                                        scope.row.propertyCode1
                                      scope.row.propertyName =
                                        scope.row.propertyName1
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              )
                            : _vm._e(),
                          !scope.row.edit &&
                          _vm.parArray.indexOf("fieldPrevent") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      scope.row.edit = !scope.row.edit
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("fieldDelect") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectEvent(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.tableData.pageNo,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.tableData.totalPage,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增客户信息字段",
            "append-to-body": "",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.addData, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "应用名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择应用名称", size: "small" },
                      model: {
                        value: _vm.addData.applicationId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addData, "applicationId", $$v)
                        },
                        expression: "addData.applicationId",
                      },
                    },
                    _vm._l(_vm.applicationNames.list, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.applicationName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "字段名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入字段名称", size: "small" },
                    model: {
                      value: _vm.addData.fieldName,
                      callback: function ($$v) {
                        _vm.$set(_vm.addData, "fieldName", $$v)
                      },
                      expression: "addData.fieldName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "字段编码" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入字段编码" },
                    model: {
                      value: _vm.addData.fieldCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.addData, "fieldCode", $$v)
                      },
                      expression: "addData.fieldCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.add },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }